import registry from './registry/registry';
import navigation from './navigation/navigation';
import header_info from './header_info/header_info';
import tramits from './tramits/tramits';
import report_error from './report_error/report_error';

const reducers = {
    registry,
    navigation,
    header_info,
    tramits,
    report_error
};

export default reducers;